import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import HomePage from './pages/HomePage';
import AIResearchAssistant from './pages/AIResearchAssistant';
import Collaboration from './pages/Collaboration';
import Profile from './pages/Profile';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import SignOut from './pages/SignOut';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PrivateRoute from './pages/PrivateRoute';
import TopNavigation from './components/layout/TopNavigation';
import { startTokenRefreshLoop, startTokenExpiryMonitor } from "./utils/auth";
import { ThemeProvider } from './utils/ThemeContext';
import { InteractiveTutorialProvider } from './utils/InteractiveTutorialContext';
import InteractiveTutorial from './components/common/InteractiveTutorial';

function App() {
  // Initialize token refresh loop and expiry monitor on app mount
  useEffect(() => {
    startTokenRefreshLoop();
    startTokenExpiryMonitor(); // Kicks out users immediately when token expires
  }, []); // Empty dependency array = run once on mount

  return (
    <ThemeProvider>
      <InteractiveTutorialProvider>
        <Router>
          <div>
            {/* Global Interactive Tutorial Component */}
            <InteractiveTutorial />
            
            <Routes>
              {/* Redirect root URL to sign-in */}
              <Route path="/" element={<Navigate to="/signin" />} />
            
            {/* Public Routes - No Navigation */}
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/signout" element={<SignOut />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Protected Routes - With Navigation */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <TopNavigation />
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <TopNavigation />
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/homepage"
              element={
                <PrivateRoute>
                  <TopNavigation />
                  <HomePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/ai-assistant"
              element={
                <PrivateRoute>
                  <TopNavigation />
                  <AIResearchAssistant />
                </PrivateRoute>
              }
            />
            <Route
              path="/collaboration"
              element={
                <PrivateRoute>
                  <TopNavigation />
                  <Collaboration />
                </PrivateRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <PrivateRoute>
                  <TopNavigation />
                  <AnalyticsDashboard />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
      </InteractiveTutorialProvider>
    </ThemeProvider>
  );
}

export default App;
